export default {
    accountApps_name: 'Name',
    accountApps_apiKey: 'API Key',
    accountApps_status: 'Status',
    accountApps_search: 'Search',
    accountApps_add: 'Add integration',
    accountApps_deleteOne: 'Delete integration',
    accountApps_deleteMany: 'Delete _COUNT_ integrations',
    accountApps_deleteSelect: 'Select an integration to delete',
    accountApps_noItems: 'There are no items.',
    accountApps_footer: 'There are no more items. · _COUNT_ integrations',
    accountApps_footerOne: 'There are no more items. · 1 integration',
    accountApps_footerMatch: '_MATCH_ of _COUNT_ integrations match.',
    accountApps_noMatch: 'No integrations match “_SEARCH_”.',
    accountApps_clearSearch: 'Clear search',
    accountApps_copyKey: 'Copy API Key',
    accountApps_copied: 'Copied',
    accountApps_copyError: 'The API Key could not be copied. Please try again.',
    accountApps_active: 'Active',
    accountApps_inactive: 'Inactive',
    accountApps_pillActive: 'Integration active',
    accountApps_pillSyncs: 'Active: vehicles sync daily with _APP_',
    accountApps_pillInactiveTip: 'Inactive: no vehicle sync or transmission',
    accountApps_transmittingLast: 'Transmitting · last _TIME_',
    accountApps_lastTransmission: 'Last transmission _TIME_',
    accountApps_noTransmissions: 'No transmissions yet',
    accountApps_telemetryTip: 'Today in _TZ_: _SENT_ transmissions · _ERRORS_ errors.',
    accountApps_linked: '_COUNT_ vehicles linked',
    accountApps_linkedOne: '1 vehicle linked',
    accountApps_openLinked: 'Open linked vehicles',
    accountApps_syncing: 'Syncing vehicles',
    accountApps_syncingCount: 'Syncing vehicles · _COUNT_ read',
    accountApps_syncDone: 'Vehicle sync completed. _COUNT_ vehicles are linked with _APP_.',
    accountApps_syncDoneOne: 'Vehicle sync completed. 1 vehicle is linked with _APP_.',
    accountApps_syncFailed: 'The vehicle sync with _APP_ could not be completed. Please try again later.',
    accountApps_syncSlow: 'The vehicle sync with _APP_ is taking longer than expected. The linked vehicles will appear when it finishes.',
    accountApps_syncSlowTitle: 'Still syncing',
    accountApps_deleted: 'Integration deleted',
    accountApps_deletedMany: '_COUNT_ integrations deleted',
    accountApps_deleteTitle: 'Delete integrations',
    accountApps_deleteWarning: 'Are you sure you want to delete the following integrations? _PRODUCT_ stops transmitting vehicle movements to them.',
    accountApps_updated: 'Integration updated successfully',

    accountAppsWizard_title: 'New integration',
    accountAppsWizard_close: 'Close',
    accountAppsWizard_selectApp: 'Select an app to see the steps for that connection.',
    accountAppsWizard_rowPreview: 'Row preview',
    accountAppsWizard_rowPreviewSub: 'This row is added to Apps when you finish.',
    accountAppsWizard_stepApp: 'App',
    accountAppsWizard_stepAppSub: 'Choose where data goes',
    accountAppsWizard_stepKey: 'API Key',
    accountAppsWizard_stepKeySub: 'The only thing we need',
    accountAppsWizard_stepVerify: 'Load catalog',
    accountAppsWizard_stepVerifySub: 'Check the connection',
    accountAppsWizard_stepSync: 'Finish',
    accountAppsWizard_stepSyncSub: 'Vehicles load in background',
    accountAppsWizard_pickTitle: 'Extend _PRODUCT_',
    accountAppsWizard_pickSub: 'Connect _PRODUCT_ with the apps your fleet needs to optimize your processes.',
    accountAppsWizard_appAvailable: '1 app available',
    accountAppsWizard_appsAvailable: '_COUNT_ apps available',
    accountAppsWizard_appsConnected: ' · _COUNT_ connected',
    accountAppsWizard_searchApps: 'Search apps',
    accountAppsWizard_noApps: 'No apps match “_SEARCH_”.',
    accountAppsWizard_noAppsAvailable: 'There are no apps available to connect.',
    accountAppsWizard_loadingApps: 'Loading apps…',
    accountAppsWizard_appsError: 'The apps could not be loaded.',
    accountAppsWizard_keyTitle: 'Enter your _APP_ API Key',
    accountAppsWizard_keySub: "That's all we need. The integration is named _APP_ and starts as Active.",
    accountAppsWizard_keyPlaceholder: 'API Key',
    accountAppsWizard_keyRequired: 'API Key is required',
    accountAppsWizard_keyHint: 'Paste the key exactly as _APP_ shows it. No formatting is applied.',
    accountAppsWizard_showKey: 'Show API Key',
    accountAppsWizard_hideKey: 'Hide API Key',
    accountAppsWizard_verify: 'Verify',
    accountAppsWizard_verifying: 'Verifying…',
    accountAppsWizard_verified: 'Verified',
    accountAppsWizard_keyAccepted: '_APP_ accepted this API Key. Click Next to continue.',
    accountAppsWizard_keyAcceptedAccount: '_APP_ accepted this API Key for _ACCOUNT_. Click Next to continue.',
    accountAppsWizard_keyRejected: '_APP_ rejected this API Key. Check it and verify again.',
    accountAppsWizard_keyStale: 'The key changed since it was verified. Verify it again.',
    accountAppsWizard_keyUnreachable: 'Could not reach _APP_. Check your network connection and try again.',
    accountAppsWizard_verifyTitleRunning: 'Verifying connection…',
    accountAppsWizard_verifyTitleDone: 'Connection verified',
    accountAppsWizard_verifyTitleFailed: 'Connection failed',
    accountAppsWizard_verifySub: 'Checking the connection before anything is saved.',
    accountAppsWizard_checkReach: 'Reaching _APP_ API',
    accountAppsWizard_checkAuth: 'Authenticating API Key',
    accountAppsWizard_checkPassed: 'PASSED',
    accountAppsWizard_checkFailed: 'FAILED',
    accountAppsWizard_checkChecking: 'CHECKING',
    accountAppsWizard_checkPending: 'PENDING',
    accountAppsWizard_failNet: 'Could not reach _APP_ (connection timed out). Check your network connection and try again.',
    accountAppsWizard_failAuth: '_APP_ rejected this API Key. Check it and try again.',
    accountAppsWizard_failVehicles: "_APP_ accepted this API Key, but it can't read the fleet's vehicles. Check the key permissions in _APP_ and try again.",
    accountAppsWizard_keyNoVehicles: "_APP_ accepted this API Key, but it can't read the fleet's vehicles. Check its permissions and verify again.",
    accountAppsWizard_checkVehicles: 'Checking access to vehicles',
    accountAppsWizard_checkVehiclesNone: 'NO VEHICLES',
    accountAppsWizard_checkVehiclesUnknown: 'NOT VERIFIED',
    accountAppsWizard_noVehiclesWarning: '_APP_ has no vehicles in this fleet yet: the sync will link none until there are vehicles.',
    accountAppsWizard_vehiclesUnknownWarning: 'The API Key works, but _APP_ did not answer the vehicles check in time. You can continue: the sync reads the vehicles later.',
    accountAppsWizard_syncTitle: 'Ready to sync your vehicles',
    accountAppsWizard_syncSub: "We'll sync the vehicles you have enabled for integration in _APP_. This can take a few minutes. We'll notify you when the process finishes.",
    accountAppsWizard_syncSaved: 'Integration saved',
    accountAppsWizard_syncSavedSub: '_APP_ row added with status Active',
    accountAppsWizard_syncVehicles: 'Vehicle sync',
    accountAppsWizard_syncVehiclesSub: 'Active vehicles enabled for integration in _APP_. Runs in the background, a few minutes.',
    accountAppsWizard_syncNotification: 'Notification',
    accountAppsWizard_syncNotificationSub: 'Open your linked vehicles from it',
    accountAppsWizard_cancel: 'Cancel',
    accountAppsWizard_back: 'Back',
    accountAppsWizard_next: 'Next',
    accountAppsWizard_continue: 'Continue',
    accountAppsWizard_finish: 'Finish',
    accountAppsWizard_retry: 'Retry',
    accountAppsWizard_editKey: 'Edit API Key',
    accountAppsWizard_connected: '_APP_ connected. The integration is Active.',
    accountAppsWizard_alreadyConnected: 'Already connected',
    accountAppsWizard_connect: 'Connect _APP_',

    accountAppsMenu_options: 'Integration options',
    accountAppsMenu_edit: 'Edit integration',
    accountAppsMenu_linkedVehicles: 'Linked vehicles',
    accountAppsMenu_linkedVehiclesLocked: 'Available when sync finishes',

    accountAppsEdit_title: 'Edit _APP_ Integration',
    accountAppsEdit_close: 'Close',
    accountAppsEdit_name: 'Name',
    accountAppsEdit_keyHint: 'Click the field and paste a new key to replace the current one. New keys must be verified before saving.',
    accountAppsEdit_keyAccepted: '_APP_ accepted this API Key. You can save now.',
    accountAppsEdit_keyAcceptedAccount: '_APP_ accepted this API Key for _ACCOUNT_. You can save now.',
    accountAppsEdit_status: 'Status',
    accountAppsEdit_info: 'When the status is Inactive, _PRODUCT_ stops transmitting vehicle movements to _APP_. The transmission log is kept for 7 days.',
    accountAppsEdit_cancel: 'Cancel',
    accountAppsEdit_save: 'Save',
    accountAppsEdit_saving: 'Saving…',

    accountAppsConsole_title: '_APP_ linked vehicles',
    accountAppsConsole_sub: 'Live view · updates while this window is open',
    accountAppsConsole_close: 'Close',
    accountAppsConsole_viewLog: 'View transmission log',
    accountAppsConsole_live: 'Live',
    accountAppsConsole_idle: 'Idle',
    accountAppsConsole_paused: 'Paused',
    accountAppsConsole_liveLast: 'last _TIME_',
    accountAppsConsole_idleLast: 'last transmission _TIME_',
    accountAppsConsole_liveWaiting: 'waiting for the first movement',
    accountAppsConsole_pausedInactive: 'integration is Inactive',
    accountAppsConsole_secondsAgo: '_N_s ago',
    accountAppsConsole_minutesAgo: '_N_ min ago',
    accountAppsConsole_hoursAgo: '_N_ h ago',
    accountAppsConsole_kpiLinked: 'Linked & active',
    accountAppsConsole_kpiLinkedTip: 'Transmitting to _APP_',
    accountAppsConsole_kpiUnmatched: 'Not matched',
    accountAppsConsole_kpiUnmatchedTip: 'VIN has no matching _PRODUCT_ unit',
    accountAppsConsole_kpiErrors: 'Transmission errors today',
    accountAppsConsole_kpiErrorsTip: 'Open the log filtered by errors',
    accountAppsConsole_kpiToday: 'Transmissions today',
    accountAppsConsole_kpiTodayTip: 'Sent to _APP_ since midnight _TZ_',
    accountAppsConsole_vehicles: 'Vehicles',
    accountAppsConsole_filter_linked: 'Linked',
    accountAppsConsole_filter_unmatched: 'Not matched',
    accountAppsConsole_filter_all: 'All',
    accountAppsConsole_search: 'Search unit, name or VIN',
    accountAppsConsole_colUnit: 'Unit',
    accountAppsConsole_colVehicle: '_APP_ vehicle',
    accountAppsConsole_colLink: 'Link',
    accountAppsConsole_colLast: 'Last transmission',
    accountAppsConsole_colToday: 'Today',
    accountAppsConsole_notMatched: 'Not matched',
    accountAppsConsole_link_linked: 'Linked',
    accountAppsConsole_link_linkedTip: 'Matched to a _PRODUCT_ unit and active in _APP_',
    accountAppsConsole_link_unmatched: 'Not matched',
    accountAppsConsole_link_unmatchedTip: 'No _PRODUCT_ unit matches this VIN',
    accountAppsConsole_link_inactive: 'Inactive',
    accountAppsConsole_link_inactiveTip: 'Inactive in _APP_. Not transmitted.',
    accountAppsConsole_lastFailed: 'Failed',
    accountAppsConsole_waitingFirst: 'Waiting for first movement',
    accountAppsConsole_notTransmitted: 'Not transmitted',
    accountAppsConsole_rowLogTip: "View today's log for _UNIT_",
    accountAppsConsole_noMatch: 'No vehicles match',
    accountAppsConsole_clearFilters: 'Clear filters',
    accountAppsConsole_noVehicles: 'No vehicles synced yet',
    accountAppsConsole_loadError: 'The vehicles could not be loaded.',

    accountAppsLog_title: 'Transmission Log',
    accountAppsLog_sub: '_APP_ · retained 7 days · times in _TZ_',
    accountAppsLog_close: 'Close',
    accountAppsLog_download: 'Download _RANGE_ as CSV',
    accountAppsLog_downloadErrors: 'Download _RANGE_ (errors only) as CSV',
    accountAppsLog_range_today: 'Today',
    accountAppsLog_range_yesterday: 'Yesterday',
    accountAppsLog_range_last7days: 'Last 7 Days',
    accountAppsLog_all: 'All',
    accountAppsLog_errors: 'Errors',
    accountAppsLog_clearUnit: 'Show all vehicles',
    accountAppsLog_colTime: 'Time',
    accountAppsLog_colUnit: 'Unit',
    accountAppsLog_colEvent: 'Event',
    accountAppsLog_colResponse: 'Response',
    accountAppsLog_eventDefault: 'Telemetry',
    accountAppsLog_odometer: '_MI_ mi',
    accountAppsLog_speed: '_MPH_ mph',
    accountAppsLog_endpoint: 'ENDPOINT',
    accountAppsLog_ok: 'OK',
    accountAppsLog_retry: 'retry',
    accountAppsLog_error: 'Error',
    accountAppsLog_deliveredTip: 'Delivered in _MS_ ms',
    accountAppsLog_deliveredRetryTip: 'Delivered in _MS_ ms after _N_ attempts',
    accountAppsLog_errorTip: 'Click for details',
    accountAppsLog_errorCodeTip: '_STATUS_ · click for details',
    accountAppsLog_retriedBackoff: '(retried with backoff)',
    accountAppsLog_noResponse: 'No response from the app',
    accountAppsLog_attempts: 'ATTEMPTS',
    accountAppsLog_latency: 'LATENCY',
    accountAppsLog_vin: 'VIN',
    accountAppsLog_readingTime: 'READING TIME',
    accountAppsLog_empty: 'No transmissions in this range',
    accountAppsLog_loadError: 'The transmissions could not be loaded.',
    accountAppsLog_footerMore: 'Showing latest _SHOWN_ of _TOTAL_ · download the CSV for the full range',
    accountAppsLog_footerCount: '_COUNT_ transmissions · _ERRORS_ errors',
    accountAppsLog_exported: '_COUNT_ transmissions exported',
    accountAppsLog_exportTruncated: 'The export stopped at _COUNT_ transmissions. Choose a shorter range for the rest.',
    accountAppsLog_exportEmpty: 'No transmissions in this range',
    accountAppsLog_exportError: 'The transmissions could not be exported.',
    accountAppsLog_csvTime: 'Time _TZ_',
    accountAppsLog_csvTimeUtc: 'Time UTC',
    accountAppsLog_csvUnit: 'Unit',
    accountAppsLog_csvVin: 'VIN',
    accountAppsLog_csvProviderVehicle: '_APP_ vehicle ID',
    accountAppsLog_csvEvent: 'Event',
    accountAppsLog_csvReadingTime: 'Reading time UTC',
    accountAppsLog_csvLatitude: 'Latitude',
    accountAppsLog_csvLongitude: 'Longitude',
    accountAppsLog_csvSpeed: 'Speed (mph)',
    accountAppsLog_csvOdometer: 'Odometer (mi)',
    accountAppsLog_csvStatus: 'Status',
    accountAppsLog_csvHttpStatus: 'HTTP status',
    accountAppsLog_csvError: 'Error',
    accountAppsLog_csvAttempts: 'Attempts',
    accountAppsLog_csvLatency: 'Latency (ms)',

    // Texts of the catalog apps' wizardConfig (fleet.integrations): accountAppsCatalog_<code>_*
    accountAppsCatalog_coastpay_description: 'Fuel cards & fleet payments',
    accountAppsCatalog_coastpay_apiKeyHelp: 'Find it in CoastPay under Integrations > API Keys.',
};
